import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio",
  "use": "icon-radio-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-radio\"><g><g><g style=\"opacity:0;\"><rect x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"0\" fill=\"#D8D8D8\" fill-opacity=\"1\" /></g><g><rect x=\"1.5\" y=\"1.5\" width=\"13\" height=\"13\" rx=\"6.5\" fill-opacity=\"0\" stroke-opacity=\"1\" stroke=\"#999999\" fill=\"none\" stroke-width=\"1\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol